const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3842 31.8052C21.7855 32.3887 21.7853 33.3502 22.3834 33.9341L23.1222 34.6729C23.4258 34.9911 23.8322 35.12 24.19 35.12C24.5682 35.12 24.9523 34.9784 25.2503 34.6803L27.5003 32.4303C28.0832 31.8474 28.0832 30.8926 27.5003 30.3097L27.5004 30.3096L27.4913 30.3008C26.9056 29.7346 25.9674 29.7219 25.3797 30.3097L24.1418 31.5475C23.5784 31.2507 22.8652 31.3281 22.3842 31.8052ZM22.3842 24.8052C21.7855 25.3887 21.7853 26.3502 22.3834 26.9341L23.1222 27.6729C23.4258 27.9911 23.8322 28.12 24.19 28.12C24.5682 28.12 24.9523 27.9784 25.2503 27.6803L27.5003 25.4303C28.0832 24.8474 28.0832 23.8926 27.5003 23.3097L27.5004 23.3096L27.4913 23.3008C26.9056 22.7346 25.9674 22.7219 25.3797 23.3097L24.1418 24.5475C23.5784 24.2507 22.8652 24.3281 22.3842 24.8052ZM24.81 19.75H33.19C34.8608 19.75 36.1045 20.2451 36.9297 21.0703C37.7549 21.8955 38.25 23.1392 38.25 24.81V33.19C38.25 34.8608 37.7549 36.1045 36.9297 36.9297C36.1045 37.7549 34.8608 38.25 33.19 38.25H24.81C23.1392 38.25 21.8955 37.7549 21.0703 36.9297C20.2451 36.1045 19.75 34.8608 19.75 33.19V24.81C19.75 23.1392 20.2451 21.8955 21.0703 21.0703C21.8955 20.2451 23.1392 19.75 24.81 19.75ZM29.31 34.37H34.56C35.4007 34.37 36.06 33.6877 36.06 32.87C36.06 32.0523 35.4007 31.37 34.56 31.37H29.31C28.4858 31.37 27.81 32.0458 27.81 32.87C27.81 33.6942 28.4858 34.37 29.31 34.37ZM29.31 27.37H34.56C35.4007 27.37 36.06 26.6877 36.06 25.87C36.06 25.0523 35.4007 24.37 34.56 24.37H29.31C28.4858 24.37 27.81 25.0458 27.81 25.87C27.81 26.6942 28.4858 27.37 29.31 27.37Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualLink);
export default __webpack_public_path__ + "static/media/manual-link.e6596d6a6065e089279693de8ea3f54c.svg";
export { ForwardRef as ReactComponent };